import { EditExploreSectionForm } from "@/components/Explore";
import type { ExploreSection } from "@/types";
import { Modal } from "@/ui";
import type { ModalProps } from "@/ui";

type Props = Pick<ModalProps, "show" | "onClose"> & {
  section: ExploreSection;
};

export const EditExploreSectionModal = ({ show, onClose, section }: Props) => {
  return (
    <Modal
      show={show}
      title="Edit Section"
      description="Update the section details below"
      onClose={onClose}
    >
      <EditExploreSectionForm section={section} onClose={onClose} />
    </Modal>
  );
};
